import { render, staticRenderFns } from "./UserActivityView.vue?vue&type=template&id=053ce550&scoped=true&"
import script from "./UserActivityView.vue?vue&type=script&lang=js&"
export * from "./UserActivityView.vue?vue&type=script&lang=js&"
import style0 from "./UserActivityView.vue?vue&type=style&index=0&id=053ce550&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053ce550",
  null
  
)

export default component.exports